import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {TargetGroupAnalytics} from '../models/target-group-analytics.model';
import {TargetGroupAnalyticsRepository} from '../repositories/target-group-analytics.repository';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import {ExportRepository} from '../repositories/export.repository';

@Injectable()
export class TargetGroupAnalyticsService {

  constructor(
    private repository: TargetGroupAnalyticsRepository,
    private exportRepository: ExportRepository
  ) {}

  public getAnalytics(from: string, to: string, targetGroupIds: Array<string>): Observable<TargetGroupAnalytics> {
    return this.repository.getAnalytics(from, to, targetGroupIds);
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.exportRepository.getAllTargetGroups();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/services/target-group-analytics.service.ts